import React from "react";
import CurrencyFormat from "react-currency-format";

const Price = ({ value }) => {
  value = parseFloat(value).toFixed(2);
  return (
    <CurrencyFormat
      value={value}
      displayType={"text"}
      thousandSeparator={true}
      prefix={"£"}
      className="sb-price"
    />
  );
};

export default Price;
